// import React, { useState, useEffect } from 'react';
// import { Ban, AlertTriangle, Search, Check, Eye, X, DollarSign } from 'lucide-react';

// const FraudManager = () => {
//   const [fraudCases, setFraudCases] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedCase, setSelectedCase] = useState(null);

//   useEffect(() => {
//     setTimeout(() => {
//       setFraudCases([
//         { id: 1, caseNumber: 'FRD001', type: 'duplicate_claims', description: 'Multiple identical claims detected', status: 'investigating', riskScore: 85, createdDate: '2025-09-21' },
//         { id: 2, caseNumber: 'FRD002', type: 'provider_anomaly', description: 'Unusual billing patterns from provider', status: 'confirmed', riskScore: 92, createdDate: '2025-09-19' },
//         { id: 3, caseNumber: 'FRD003', type: 'member_pattern', description: 'Suspicious claim frequency', status: 'closed', riskScore: 67, createdDate: '2025-09-15' }
//       ]);
//       setLoading(false);
//     }, 500);
//   }, []);

//   const getFraudStatusColor = (status) => {
//     switch (status) {
//       case 'confirmed': return 'bg-red-100 text-red-800';
//       case 'investigating': return 'bg-yellow-100 text-yellow-800';
//       case 'closed': return 'bg-gray-100 text-gray-800';
//       default: return 'bg-blue-100 text-blue-800';
//     }
//   };

//   const getRiskScoreColor = (score) => {
//     if (score >= 80) return 'text-red-600 bg-red-100';
//     if (score >= 60) return 'text-yellow-600 bg-yellow-100';
//     return 'text-green-600 bg-green-100';
//   };

//   if (loading) return <div className="p-6">Loading fraud cases...</div>;

//   return (
//     <div className="p-6">
//       <div className="flex justify-between items-center mb-6">
//         <div>
//           <h2 className="text-2xl font-bold text-gray-900">Fraud Management</h2>
//           <p className="text-gray-600 mt-1">Monitor and investigate suspicious activities</p>
//         </div>

//         <button className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center">
//           <Ban className="h-4 w-4 mr-2" />
//           Ban Management
//         </button>
//       </div>

//       {/* Fraud Stats */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-red-100">
//               <AlertTriangle className="h-6 w-6 text-red-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Active Cases</p>
//               <p className="text-2xl font-bold text-gray-900">23</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-yellow-100">
//               <Search className="h-6 w-6 text-yellow-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Investigating</p>
//               <p className="text-2xl font-bold text-gray-900">8</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-green-100">
//               <Check className="h-6 w-6 text-green-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Resolved</p>
//               <p className="text-2xl font-bold text-gray-900">45</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-sm border p-6">
//           <div className="flex items-center">
//             <div className="p-3 rounded-full bg-purple-100">
//               <DollarSign className="h-6 w-6 text-purple-600" />
//             </div>
//             <div className="ml-4">
//               <p className="text-sm font-medium text-gray-600">Saved</p>
//               <p className="text-2xl font-bold text-gray-900">$45K</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Fraud Cases Table */}
//       <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="min-w-full divide-y divide-gray-200">
//             <thead className="bg-gray-50">
//               <tr>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Case
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Type
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Risk Score
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Status
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Date
//                 </th>
//                 <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   Actions
//                 </th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {fraudCases.map((fraudCase) => (
//                 <tr key={fraudCase.id} className="hover:bg-gray-50">
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <div>
//                       <div className="text-sm font-medium text-gray-900">{fraudCase.caseNumber}</div>
//                       <div className="text-sm text-gray-500 truncate max-w-xs">{fraudCase.description}</div>
//                     </div>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                       {fraudCase.type.replace('_', ' ')}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRiskScoreColor(fraudCase.riskScore)}`}>
//                       {fraudCase.riskScore}%
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap">
//                     <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getFraudStatusColor(fraudCase.status)}`}>
//                       {fraudCase.status}
//                     </span>
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                     {fraudCase.createdDate}
//                   </td>
//                   <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                     <div className="flex space-x-2">
//                       <button
//                         onClick={() => setSelectedCase(fraudCase)}
//                         className="text-blue-600 hover:text-blue-900"
//                       >
//                         <Eye className="h-4 w-4" />
//                       </button>
//                       {fraudCase.status === 'investigating' && (
//                         <>
//                           <button className="text-red-600 hover:text-red-900">
//                             <Ban className="h-4 w-4" />
//                           </button>
//                           <button className="text-green-600 hover:text-green-900">
//                             <Check className="h-4 w-4" />
//                           </button>
//                         </>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Fraud Case Details Modal */}
//       {selectedCase && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//             <div className="flex justify-between items-center mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Fraud Case Details</h3>
//               <button
//                 onClick={() => setSelectedCase(null)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="space-y-4">
//               <div className="grid grid-cols-2 gap-4">
//                 <div>
//                   <label className="text-sm font-medium text-gray-500">Case Number</label>
//                   <p className="text-gray-900">{selectedCase.caseNumber}</p>
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-500">Risk Score</label>
//                   <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRiskScoreColor(selectedCase.riskScore)}`}>
//                     {selectedCase.riskScore}%
//                   </span>
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-500">Type</label>
//                   <p className="text-gray-900 capitalize">{selectedCase.type.replace('_', ' ')}</p>
//                 </div>
//                 <div>
//                   <label className="text-sm font-medium text-gray-500">Status</label>
//                   <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getFraudStatusColor(selectedCase.status)}`}>
//                     {selectedCase.status}
//                   </span>
//                 </div>
//               </div>

//               <div>
//                 <label className="text-sm font-medium text-gray-500">Description</label>
//                 <p className="text-gray-900 mt-1">{selectedCase.description}</p>
//               </div>

//               <div className="bg-red-50 p-4 rounded-lg">
//                 <h4 className="font-medium text-red-900 mb-2">Investigation Notes</h4>
//                 <p className="text-sm text-red-800">This case requires immediate attention due to high risk score and suspicious patterns detected.</p>
//               </div>

//               {selectedCase.status === 'investigating' && (
//                 <div className="flex space-x-3 pt-4">
//                   <button className="flex-1 bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 flex items-center justify-center">
//                     <Ban className="h-4 w-4 mr-2" />
//                     Confirm Fraud
//                   </button>
//                   <button className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 flex items-center justify-center">
//                     <Check className="h-4 w-4 mr-2" />
//                     Clear Case
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FraudManager;

import React, { useState, useEffect } from "react";
import { Shield, AlertTriangle, Check, Ban, PlusCircle, X } from "lucide-react";
import apiService from "../../services/apiService";

const FraudManager = () => {
  const [fraudCases, setFraudCases] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedCase, setSelectedCase] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCase, setNewCase] = useState({
    type: "",
    description: "",
    risk_score: 0,
    related_member_id: "",
    related_claim_id: "",
    evidence: {
      duplicate_count: "",
      time_span: "",
      identical_amounts: false,
      same_provider: false,
    },
  });

  // Fetch fraud cases + stats
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [casesRes, statsRes] = await Promise.all([
          apiService.getFraudCases(),
          apiService.getFraudStats(),
        ]);
        setFraudCases(casesRes?.data || []);
        setStats(statsRes?.data || {});
      } catch (error) {
        console.error("Failed to load fraud cases:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Update fraud case status
  const handleUpdateCase = async (id, status, notes) => {
    try {
      await apiService.updateFraudCase(id, { status, notes });
      const refreshed = await apiService.getFraudCases();
      setFraudCases(refreshed);
      setSelectedCase(null);
    } catch (error) {
      console.error("Error updating fraud case:", error);
    }
  };

  // Create fraud case
  const handleCreateFraudCase = async () => {
    try {
      await apiService.createFraudCase(newCase);
      const refreshed = await apiService.getFraudCases();
      setFraudCases(refreshed);
      setShowCreateModal(false);
      setNewCase({
        type: "",
        description: "",
        risk_score: 0,
        related_member_id: "",
        related_claim_id: "",
        evidence: {
          duplicate_count: "",
          time_span: "",
          identical_amounts: false,
          same_provider: false,
        },
      });
    } catch (error) {
      console.error("Error creating fraud case:", error);
    }
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Shield className="h-6 w-6 text-red-600" />
          Fraud Detection & Management
        </h1>
        <button
          onClick={() => setShowCreateModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
        >
          <PlusCircle className="h-4 w-4" />
          New Case
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {loading ? (
          <p>Loading stats...</p>
        ) : (
          <>
            <div className="bg-white p-6 rounded-xl shadow">
              <p className="text-sm text-gray-500">Active Cases</p>
              <p className="text-2xl font-bold">{stats.activeCases || 0}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <p className="text-sm text-gray-500">Investigating</p>
              <p className="text-2xl font-bold">{stats.investigating || 0}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <p className="text-sm text-gray-500">Resolved</p>
              <p className="text-2xl font-bold">{stats.resolved || 0}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <p className="text-sm text-gray-500">Amount Saved</p>
              <p className="text-2xl font-bold">${stats.savedAmount || 0}</p>
            </div>
          </>
        )}
      </div>

      {/* Fraud Cases */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <div className="p-6 border-b">
          <h2 className="text-lg font-semibold flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            Fraud Cases
          </h2>
        </div>

        {loading ? (
          <p className="p-6">Loading fraud cases...</p>
        ) : fraudCases.length === 0 ? (
          <p className="p-6 text-gray-500">No fraud cases found.</p>
        ) : (
          <ul className="divide-y">
            {fraudCases.map((caseItem) => (
              <li
                key={caseItem.id}
                onClick={() => setSelectedCase(caseItem)}
                className="p-6 hover:bg-gray-50 cursor-pointer flex justify-between"
              >
                <div>
                  <p className="font-medium">
                    Case #{caseItem.id}: {caseItem.type}
                  </p>
                  <p className="text-sm text-gray-600">
                    {caseItem.description}
                  </p>
                </div>
                <span
                  className={`px-2 py-1 text-xs rounded-full ${
                    caseItem.status === "investigating"
                      ? "bg-yellow-100 text-yellow-800"
                      : caseItem.status === "confirmed"
                      ? "bg-red-100 text-red-800"
                      : "bg-green-100 text-green-800"
                  }`}
                >
                  {caseItem.status}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Case Details Modal */}
      {selectedCase && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-6 space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold">Fraud Case Details</h3>
              <button
                onClick={() => setSelectedCase(null)}
                className="p-2 hover:bg-gray-100 rounded-full"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <p>
              <span className="font-medium">Type:</span> {selectedCase.type}
            </p>
            <p>
              <span className="font-medium">Description:</span>{" "}
              {selectedCase.description}
            </p>
            <p>
              <span className="font-medium">Risk Score:</span>{" "}
              {selectedCase.risk_score}
            </p>

            {selectedCase.evidence && (
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-medium mb-2">Evidence</h4>
                <ul className="text-sm text-gray-700 list-disc pl-5 space-y-1">
                  <li>
                    Duplicate Count: {selectedCase.evidence.duplicate_count}
                  </li>
                  <li>Time Span: {selectedCase.evidence.time_span}</li>
                  <li>
                    Identical Amounts:{" "}
                    {selectedCase.evidence.identical_amounts ? "Yes" : "No"}
                  </li>
                  <li>
                    Same Provider:{" "}
                    {selectedCase.evidence.same_provider ? "Yes" : "No"}
                  </li>
                </ul>
              </div>
            )}

            <div className="flex gap-4">
              <button
                onClick={() =>
                  handleUpdateCase(
                    selectedCase.id,
                    "confirmed",
                    "Investigation completed. Confirmed fraud."
                  )
                }
                className="flex-1 bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 flex items-center justify-center"
              >
                <Ban className="h-4 w-4 mr-2" />
                Confirm Fraud
              </button>
              <button
                onClick={() =>
                  handleUpdateCase(
                    selectedCase.id,
                    "closed",
                    "Investigation completed. Case cleared."
                  )
                }
                className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 flex items-center justify-center"
              >
                <Check className="h-4 w-4 mr-2" />
                Clear Case
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Create Case Modal */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-6 space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold">New Fraud Case</h3>
              <button
                onClick={() => setShowCreateModal(false)}
                className="p-2 hover:bg-gray-100 rounded-full"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <input
              type="text"
              placeholder="Type"
              value={newCase.type}
              onChange={(e) => setNewCase({ ...newCase, type: e.target.value })}
              className="w-full border p-2 rounded"
            />
            <textarea
              placeholder="Description"
              value={newCase.description}
              onChange={(e) =>
                setNewCase({ ...newCase, description: e.target.value })
              }
              className="w-full border p-2 rounded"
            />
            <input
              type="number"
              placeholder="Risk Score"
              value={newCase.risk_score}
              onChange={(e) =>
                setNewCase({ ...newCase, risk_score: Number(e.target.value) })
              }
              className="w-full border p-2 rounded"
            />
            <input
              type="number"
              placeholder="Related Member ID"
              value={newCase.related_member_id}
              onChange={(e) =>
                setNewCase({ ...newCase, related_member_id: e.target.value })
              }
              className="w-full border p-2 rounded"
            />
            <input
              type="number"
              placeholder="Related Claim ID"
              value={newCase.related_claim_id}
              onChange={(e) =>
                setNewCase({ ...newCase, related_claim_id: e.target.value })
              }
              className="w-full border p-2 rounded"
            />

            <button
              onClick={handleCreateFraudCase}
              className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700"
            >
              Create Case
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FraudManager;
